package com.tovtalk.data.repository

import com.lomdaat.ads.model.AdsIdentity
import com.lomdaat.ads.model.AdsRequestId
import com.lomdaat.ads.platform.AdsIdentityProvider
import kotlinx.browser.window

class WebAdsIdentityProvider : AdsIdentityProvider {

    override suspend fun getAdsIdentity(): AdsIdentity {
        val id = getOrCreateInstallId()
        return AdsIdentity(
            requestId = AdsRequestId(id),
            trackingAllowed = false,
        )
    }

    private fun getOrCreateInstallId(): String {
        val storage = window.localStorage
        val existing = storage.getItem(INSTALL_ID_KEY)
        if (!existing.isNullOrBlank()) return existing

        val chars = "abcdefghijklmnopqrstuvwxyz0123456789"
        val id = (1..36).map {
            if (it == 9 || it == 14 || it == 19 || it == 24) '-'
            else chars.random()
        }.joinToString("")
        storage.setItem(INSTALL_ID_KEY, id)
        return id
    }

    private companion object {
        const val INSTALL_ID_KEY = "lomdaat_ads_install_id"
    }
}
